import React from 'react';
import AdminSidebar from '../components/AdminSidebar';
import AvaliacoesList from './AvaliacoesList';

const mainStyle = {
  marginLeft: '220px',
  padding: '2rem',
  minHeight: '100vh',
  background: '#f4f4f4'
};

export default function AdminDashboard() {
  return (
    <div>
      <AdminSidebar />

      <main style={mainStyle}>
        <h1
          style={{
            fontWeight: 700,
            fontSize: '2rem',
            marginBottom: '0.5rem',
            color: '#242F3C'
          }}
        >
          Painel Administrativo
        </h1>

        <p
          style={{
            marginTop: 0,
            marginBottom: '2rem',
            color: '#697382',
            fontSize: '1rem'
          }}
        >
          Acompanhe as avaliações realizadas e acesse os relatórios dos participantes.
        </p>

        <AvaliacoesList />
      </main>
    </div>
  );
}

